import { Box, DashboardModule } from '@domain-group/suit-theme'

import type { TaskListModel } from '@models/types'

import useAttachments from '@hooks/useAttachments'

import AttachmentListItem from '@components/AttachmentListItem'

interface AssetsProps {
  taskList: TaskListModel,
}

const Assets = (props: AssetsProps) => {
  const { taskList } = props

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_type: 'TaskListTemplate',
      attachable_id: taskList.task_list_template_id,
    },
    performHttpRequests: !!taskList.task_list_template_id,
  })

  const { filteredAttachments, hasFilteredAttachments } = attachmentsPayload

  if (!hasFilteredAttachments){
    return null
  }

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Assets"
    >
      <Box flexDirection="column">
        {filteredAttachments.map(attachment => (
          <AttachmentListItem attachment={attachment} key={attachment.id} />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default Assets
